import { useMemo } from 'react';

import { Box } from '@mui/material';

import { NoDataMessage } from '@/components/NoDataMessage';

import MiniTable from './components/MiniTable';

import type { MiniTableType } from '../types';

type MiniTableContainerProps = {
  // height?: number;
  tables: MiniTableType[];
};
const MiniTablesContainer = ({ tables }: MiniTableContainerProps) => {
  const columns = useMemo(() => {
    const result: [MiniTableType[], MiniTableType[]] = [[], []];

    for (const table of tables) {
      const index = tables.indexOf(table);
      if (index % 2 === 0) {
        result[0].push(table);
      } else {
        result[1].push(table);
      }
    }
    return result;
  }, [tables]);

  return (
    <Box
      sx={{
        display: 'flex',
        gap: '12px',
        flexDirection: {
          xs: 'column',
          md: 'row'
        },
        flex: 1,
        minHeight: '250px',
        maxHeight: '650px',
        overflowY: 'auto',
        height: '100%'
      }}
    >
      {tables.length === 0 && <NoDataMessage />}
      {columns.map((tableGroup, colIdx) => {
        const boxKey = tableGroup.map(t => t.name).join('-') || `column-${colIdx}`;

        return (
          <Box
            key={boxKey}
            sx={{ display: 'flex', flex: 1, flexDirection: 'column', gap: '12px' }}
          >
            {tableGroup.map(table => (
              <MiniTable
                key={table.name}
                table={table}
              />
            ))}
          </Box>
        );
      })}
    </Box>
  );
};

export default MiniTablesContainer;
